import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  AllocationPreview, BillOfEntry, CnfBillOption, GrnLineOptionPage, BillOfEntryPage, BillOfEntryRequest, BoeStatus, CustomsPayment, CustomsPaymentRequest,
} from '../interfaces/procurement/billOfEntry.interface';

// ---- W3-F import landed cost ----
export const BillOfEntryService = {
  list: async (institutionId: string, status?: BoeStatus | '', page = 0, size = 20): Promise<BillOfEntryPage> => {
    const params: Record<string, string | number> = { page, size };
    if (status) params.status = status;
    return (await axios.get(ENDPOINTS.BILL_OF_ENTRY.LIST(institutionId), { params })).data;
  },
  /** Server-side paged, searchable POSTED goods receipt lines for the wizard picker. */
  grnLines: async (institutionId: string, q: string, page = 0, size = 20): Promise<GrnLineOptionPage> =>
    (await axios.get(ENDPOINTS.BILL_OF_ENTRY.GRN_LINES(institutionId), { params: { q: q || undefined, page, size } })).data,
  /** Posted bills of one supplier that debited import clearing, with the amount still free to charge. */
  cnfBills: async (institutionId: string, supplierId: string, excludeBoeId?: string): Promise<CnfBillOption[]> =>
    (await axios.get(ENDPOINTS.BILL_OF_ENTRY.CNF_BILLS(institutionId), { params: { supplierId, excludeBoeId } })).data,
  getById: async (id: string): Promise<BillOfEntry> => (await axios.get(ENDPOINTS.BILL_OF_ENTRY.BY_ID(id))).data,
  create: async (dto: BillOfEntryRequest): Promise<BillOfEntry> => (await axios.post(ENDPOINTS.BILL_OF_ENTRY.BASE, dto)).data,
  update: async (id: string, dto: BillOfEntryRequest): Promise<BillOfEntry> =>
    (await axios.put(ENDPOINTS.BILL_OF_ENTRY.BY_ID(id), dto)).data,
  remove: async (id: string): Promise<void> => { await axios.delete(ENDPOINTS.BILL_OF_ENTRY.BY_ID(id)); },
  preview: async (dto: BillOfEntryRequest): Promise<AllocationPreview> =>
    (await axios.post(ENDPOINTS.BILL_OF_ENTRY.PREVIEW, dto)).data,
  post: async (id: string): Promise<BillOfEntry> => (await axios.post(ENDPOINTS.BILL_OF_ENTRY.POST(id))).data,
  reverse: async (id: string): Promise<BillOfEntry> => (await axios.post(ENDPOINTS.BILL_OF_ENTRY.REVERSE(id))).data,
};

export const CustomsPaymentService = {
  list: async (institutionId: string): Promise<CustomsPayment[]> =>
    (await axios.get(ENDPOINTS.CUSTOMS_PAYMENT.LIST(institutionId))).data,
  create: async (dto: CustomsPaymentRequest): Promise<CustomsPayment> =>
    (await axios.post(ENDPOINTS.CUSTOMS_PAYMENT.BASE, dto)).data,
  reverse: async (id: string): Promise<CustomsPayment> => (await axios.post(ENDPOINTS.CUSTOMS_PAYMENT.REVERSE(id))).data,
};
